export default {"src":"/_next/static/media/empty-notifications.0c26a7d8.svg","height":243,"width":244,"blurWidth":0,"blurHeight":0};